/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GssSlotOccasion } from './gssSlotOccasion';

/**
 * Create or refresh a pending connection request.
 */
export interface ConnectionRequestBody {
  /** @minLength 1 */
  targetUserId: string;
  occasion: GssSlotOccasion;
}
